/**
 * ألعاب لا تُعرض للطالب (مثلاً سجلات تجريبية بقيت في الـ API).
 * الحذف الفعلي من قاعدة البيانات يتم من لوحة الإدارة أو الـ backend.
 */

const HIDDEN_STUDENT_GAME_NAMES = new Set(['لعبة تجريبية']);

export function normalizeGameName(name) {
  return String(name ?? '')
    .replace(/\s+/g, ' ')
    .trim();
}

export function isHiddenStudentGame(name) {
  return HIDDEN_STUDENT_GAME_NAMES.has(normalizeGameName(name));
}
